import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import './styles.scss';
import DynamicModal from '../Modal';
import moment from 'moment';

const July4SaleContent = () => {
    // Check if current time is between July 5th EST and 11:59 July 6th EST
    const isOfferExpirationVisible = () => {
        if (typeof window === 'undefined') return false;

        const now = new Date();
        const currentYear = now.getFullYear();

        // Create dates in EST timezone
        const july5Start = new Date(`${currentYear}-07-16T00:00:00-04:00`);
        const july6End = new Date(`${currentYear}-07-27T23:59:59-04:00`);

        return now >= july5Start && now <= july6End;
    };

    return (
        <div style={{ marginTop: '8px' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <h2 style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    2-Day Flash Sale: <span style={{ color: '#dc3545' }}>Pay 50% LESS</span> than the rate available anywhere else online.
                    {/* {isOfferExpirationVisible() && <div id="offer-exipiration">Expires 11:59 Thursday July, 27th</div>} */}
                </h2>
            </div>

            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <img
                    src="/july_flash_25-large.png"
                    alt="Save 50% on all beach houses"
                    width="600"
                    height="405"
                />
            </div>

            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <p style={{ fontSize: '16px', fontWeight: 'bold', margin: '0 0 2px 0' }}>
                    <strong>No Risk:</strong> Cancel any time at least 30 days prior to check-in for a full refund.
                </p>
                <p style={{ fontSize: '14px', margin: '0 0 10px 0' }}>
                    (Book now to lock in 50% discount. Change dates later without penalty)
                </p>
                <p style={{ fontSize: '16px', color: '#007bff', margin: '0 0 10px 0' }}>
                    <img src="/icon-award.svg" /> <em>"Best Beach Town in America"</em> - <span style={{ fontStyle: 'italic', color: '#007bff' }}>USA Today, 2024 Winner</span>
                </p>
            </div>
        </div>
    );
};

export const Modal = ({ isOpen = false, onClose = () => { } }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
        setModalIsOpen(isOpen);
    }, [isOpen]);

    return (
        <DynamicModal
            disableFocusTrap={true}
            title=""
            removeHeader={true}
            expanded={true}
            isOpen={modalIsOpen}
            onClose={() => {
                setModalIsOpen(false);
                if (onClose) {
                    onClose();
                }
            }}
            className="july4-sale-modal"
        >
            <>
                <div className="mt-2">
                    <July4SaleContent />

                    <div style={{ textAlign: 'center' }}>
                        <button
                            onClick={() => setModalIsOpen(false)}
                            className="btn btn-secondary text-primary font-weight-bold rounded"
                        >
                            Close Window
                        </button>

                    </div>
                </div>
            </>
        </DynamicModal>
    );
};

export default July4SaleContent;
